var _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _rect11, _rect12, _rect13, _rect14, _rect15, _rect16, _rect17, _rect18, _rect19, _rect20, _rect21, _rect22, _rect23, _rect24, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";
import { forwardRef, memo } from "react";

var SvgYearsLoadingBars = function SvgYearsLoadingBars(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 240 240",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: ref
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 130.5,
    y: 239.5,
    width: 21,
    height: 64,
    transform: "rotate(-180 130.5 239.5)",
    fill: "url(#paint0_linear_1319_40160)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 130.5,
    y: 239.5,
    width: 21,
    height: 64,
    transform: "rotate(-180 130.5 239.5)",
    fill: "url(#pattern0)",
    fillOpacity: 0.05
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 130.5,
    y: 239.5,
    width: 21,
    height: 64,
    transform: "rotate(-180 130.5 239.5)",
    stroke: "white"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 43,
    y: 212.293,
    width: 21,
    height: 64,
    transform: "rotate(-135 43 212.293)",
    fill: "url(#paint1_linear_1319_40160)"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 43,
    y: 212.293,
    width: 21,
    height: 64,
    transform: "rotate(-135 43 212.293)",
    fill: "url(#pattern1)",
    fillOpacity: 0.05
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 43,
    y: 212.293,
    width: 21,
    height: 64,
    transform: "rotate(-135 43 212.293)",
    stroke: "white"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 212.293,
    y: 197,
    width: 21,
    height: 64,
    transform: "rotate(135 212.293 197)",
    fill: "url(#paint2_linear_1319_40160)"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 212.293,
    y: 197,
    width: 21,
    height: 64,
    transform: "rotate(135 212.293 197)",
    fill: "url(#pattern2)",
    fillOpacity: 0.05
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 212.293,
    y: 197,
    width: 21,
    height: 64,
    transform: "rotate(135 212.293 197)",
    stroke: "white"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 239.5,
    y: 109.5,
    width: 21,
    height: 64,
    transform: "rotate(90 239.5 109.5)",
    fill: "url(#paint3_linear_1319_40160)"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 239.5,
    y: 109.5,
    width: 21,
    height: 64,
    transform: "rotate(90 239.5 109.5)",
    fill: "url(#pattern3)",
    fillOpacity: 0.05
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 239.5,
    y: 109.5,
    width: 21,
    height: 64,
    transform: "rotate(90 239.5 109.5)",
    stroke: "white"
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 130.5,
    width: 21,
    height: 64,
    transform: "rotate(-90 0.5 130.5)",
    fill: "url(#paint4_linear_1319_40160)"
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 130.5,
    width: 21,
    height: 64,
    transform: "rotate(-90 0.5 130.5)",
    fill: "url(#pattern4)",
    fillOpacity: 0.05
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 130.5,
    width: 21,
    height: 64,
    transform: "rotate(-90 0.5 130.5)",
    stroke: "white"
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    x: 27.7071,
    y: 43,
    width: 21,
    height: 64,
    transform: "rotate(-45 27.7071 43)",
    fill: "url(#paint5_linear_1319_40160)"
  })), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    x: 27.7071,
    y: 43,
    width: 21,
    height: 64,
    transform: "rotate(-45 27.7071 43)",
    fill: "url(#pattern5)",
    fillOpacity: 0.05
  })), _rect18 || (_rect18 = /*#__PURE__*/React.createElement("rect", {
    x: 27.7071,
    y: 43,
    width: 21,
    height: 64,
    transform: "rotate(-45 27.7071 43)",
    stroke: "white"
  })), _rect19 || (_rect19 = /*#__PURE__*/React.createElement("rect", {
    x: 197,
    y: 27.7071,
    width: 21,
    height: 64,
    transform: "rotate(45 197 27.7071)",
    fill: "url(#paint6_linear_1319_40160)"
  })), _rect20 || (_rect20 = /*#__PURE__*/React.createElement("rect", {
    x: 197,
    y: 27.7071,
    width: 21,
    height: 64,
    transform: "rotate(45 197 27.7071)",
    fill: "url(#pattern6)",
    fillOpacity: 0.05
  })), _rect21 || (_rect21 = /*#__PURE__*/React.createElement("rect", {
    x: 197,
    y: 27.7071,
    width: 21,
    height: 64,
    transform: "rotate(45 197 27.7071)",
    stroke: "white"
  })), _rect22 || (_rect22 = /*#__PURE__*/React.createElement("rect", {
    x: 109.5,
    y: 0.5,
    width: 21,
    height: 64,
    fill: "url(#paint7_linear_1319_40160)"
  })), _rect23 || (_rect23 = /*#__PURE__*/React.createElement("rect", {
    x: 109.5,
    y: 0.5,
    width: 21,
    height: 64,
    fill: "url(#pattern7)",
    fillOpacity: 0.05
  })), _rect24 || (_rect24 = /*#__PURE__*/React.createElement("rect", {
    x: 109.5,
    y: 0.5,
    width: 21,
    height: 64,
    stroke: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0",
    patternContentUnits: "objectBoundingBox",
    width: 3.996,
    height: 1.35249
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_1319_40160",
    transform: "scale(0.03996 0.0135249)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "pattern1",
    patternContentUnits: "objectBoundingBox",
    width: 3.996,
    height: 1.35249
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_1319_40160",
    transform: "scale(0.03996 0.0135249)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "pattern2",
    patternContentUnits: "objectBoundingBox",
    width: 3.996,
    height: 1.35249
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_1319_40160",
    transform: "scale(0.03996 0.0135249)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "pattern3",
    patternContentUnits: "objectBoundingBox",
    width: 3.996,
    height: 1.35249
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_1319_40160",
    transform: "scale(0.03996 0.0135249)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "pattern4",
    patternContentUnits: "objectBoundingBox",
    width: 3.996,
    height: 1.35249
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_1319_40160",
    transform: "scale(0.03996 0.0135249)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "pattern5",
    patternContentUnits: "objectBoundingBox",
    width: 3.996,
    height: 1.35249
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_1319_40160",
    transform: "scale(0.03996 0.0135249)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "pattern6",
    patternContentUnits: "objectBoundingBox",
    width: 3.996,
    height: 1.35249
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_1319_40160",
    transform: "scale(0.03996 0.0135249)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "pattern7",
    patternContentUnits: "objectBoundingBox",
    width: 3.996,
    height: 1.35249
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_1319_40160",
    transform: "scale(0.03996 0.0135249)"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1319_40160",
    x1: 142,
    y1: 240,
    x2: 142,
    y2: 272.771,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1965FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1965FE",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1319_40160",
    x1: 54,
    y1: 213,
    x2: 54,
    y2: 239.477,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1965FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1965FE",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1319_40160",
    x1: 224,
    y1: 197,
    x2: 224,
    y2: 237.523,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1965FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1965FE",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1319_40160",
    x1: 251,
    y1: 109,
    x2: 251,
    y2: 158.156,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1965FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1965FE",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_1319_40160",
    x1: 11,
    y1: 131,
    x2: 11,
    y2: 144.903,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1965FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1965FE",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_1319_40160",
    x1: 38,
    y1: 43,
    x2: 38,
    y2: 52.6264,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1965FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1965FE",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_1319_40160",
    x1: 208,
    y1: 27,
    x2: 208,
    y2: 81.5646,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1965FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1965FE",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_1319_40160",
    x1: 120,
    y1: 0,
    x2: 120,
    y2: 65,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1965FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1965FE",
    stopOpacity: 0
  })))));
};

var ForwardRef = /*#__PURE__*/forwardRef(SvgYearsLoadingBars);
var Memo = /*#__PURE__*/memo(ForwardRef);
export { Memo as ReactComponent };
export default __webpack_public_path__ + "static/Years-LoadingBars.9a120203.svg";